export default __webpack_public_path__ + "static/media/IMG_9054 copie.d6753254.jpg";